/* @flow */

// Reducers shared between "main" and "public" apps

import auth from "platopulse/auth/auth";

/* ducks */
import app from "platopulse/redux/app";
import metadata from "platopulse/redux/metadata";
import requests from "platopulse/redux/requests";
import settings from "platopulse/redux/settings";
import undo from "platopulse/redux/undo";

/* user */
import { currentUser } from "platopulse/redux/user";

export default {
    // global reducers
    app,
    auth,
    currentUser,
    metadata,
    requests,
    settings,
    undo,
};



// WEBPACK FOOTER //
// ./reducers-common.js